import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  ChipContext,
  ChipStatus,
  HeadingDisplay,
  ButtonPrimary,
  BaseText,
  InitialAvatarIcon
} from '@warrenbrasil/nebraska-web';
import { Hero } from '@/modules/common/components/Hero';
import { HeadingDisplayLoader } from '@/modules/trade/components/HeadingDisplayLoader';
import { SectionError } from '@/modules/common/components/SectionError';
import { Money } from '@/modules/common/components/Money';

import { CustomerModule } from '@/modules/common/store/CustomerModule';
import { IPortfolioHero } from '@/modules/wealth/services/portfolio';
import { PortfolioCategories } from '@/types/models/Portfolio';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';
import { WealthPortfolioTabsIndexes } from '../../types';
import { Notification } from '@/modules/common/components/Notification';

interface Props {
  portfolioHero: IPortfolioHero | null;
  isLoading: boolean;
  hasError: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioHero',
  props: {
    portfolioHero: null,
    isLoading: { type: Boolean },
    hasError: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  portfolioHero: IPortfolioHero | null;
  isLoading: boolean;
  hasError: boolean;
};

const currentTabIndex = ref<WealthPortfolioTabsIndexes>(
  inject<WealthPortfolioTabsIndexes>('currentTabIndex')
);

const route = useRoute();
const router = useRouter();



const portfolioImages = computed(() => {
  return {
    full: props.portfolioHero?.image.full,
    regular: props.portfolioHero?.image.regular,
    small: props.portfolioHero?.image.small
  };
});

const heroClass = computed(() => {
  return {
    'portfolio-hero': true,
    'portfolio-hero__inactive': props.portfolioHero?.isInactive
  };
});

const portfolioType = computed(() => {
  const { type } = route.params;

  return type;
});

const isRegulatoryStatusBlocked = computed(() => {
  return CustomerModule?.isRegulatoryStatusBlocked;
});

const actionMapper: { [key: string]: Function } = {
  INVESTMENT: handleInvestmentClick,
  REDEMPTION: handleWithdrawClick,
  WARNING: handleWarningClick
};

function onChangeTab(selectedTabIndex: WealthPortfolioTabsIndexes) {
  currentTabIndex.value = selectedTabIndex;
}

function handleInvestmentClick() {
  if (isRegulatoryStatusBlocked.value) {
    redirectToRegulatoryUpdate();
    return;
  }

  const investmentRouteMapper: Record<
    PortfolioCategories,
    { name: string; params: { [key: string]: string } }
  > = {
    [PortfolioCategories.WarrenManagement]: {
      name: 'investment-transaction',
      params: { portfolio: props.portfolioHero!.id }
    },
    [PortfolioCategories.Custom]: {
      name: 'wealthProductTransaction',
      params: { id: props.portfolioHero!.id }
    },
    [PortfolioCategories.VariableIncome]: {
      name: 'variableIncomeInvestment',
      params: { id: props.portfolioHero!.id }
    }
  };

  const { name, params } =
    investmentRouteMapper[portfolioType.value as PortfolioCategories];

  router.push({ name, params });
}

function handleWithdrawClick() {
  const withdrawRouteMapper: Record<
    PortfolioCategories,
    { name: string; params: { [key: string]: string } }
  > = {
    [PortfolioCategories.WarrenManagement]: {
      name: 'withdrawByPortfolio',
      params: { id: props.portfolioHero!.id }
    },
    [PortfolioCategories.Custom]: {
      name: 'wealthProductWithdrawal',
      params: { id: props.portfolioHero!.id }
    },
    [PortfolioCategories.VariableIncome]: {
      name: 'variableIncomeWithdraw',
      params: { id: props.portfolioHero!.id }
    }
  };

  const { name, params } =
    withdrawRouteMapper[portfolioType.value as PortfolioCategories];

  router.push({ name, params });
}

function handleWarningClick() {
  notify({
    group: 'wrn-wealth',
    type: NotificationTypes.alert
  });
}

function redirectToRegulatoryUpdate() {
  router.push({
    name: 'regulatoryUpdateAnnouncement'
  });
}

return { __sfc: true,currentTabIndex, route, router, props, portfolioImages, heroClass, portfolioType, isRegulatoryStatusBlocked, actionMapper, onChangeTab, handleInvestmentClick, handleWithdrawClick, handleWarningClick, redirectToRegulatoryUpdate, NebraskaColors, ChipContext, ChipStatus, HeadingDisplay, ButtonPrimary, BaseText, InitialAvatarIcon, Hero, HeadingDisplayLoader, SectionError, Money, Notification }
}

})